module.exports = __webpack_public_path__ + "img/bg-type06-mask.222e85f1.png";